import { normalizeText, parseFormConfig, parseFormId } from '~/utils/eventTracking'

const SUBMIT_BUTTON_SELECTOR = 'button[type="submit"], button[data-submit-action], input[type="submit"]'

/**
 * Get the submit button element for a given element.
 * @param element
 */
export const getSubmitButton = (element) => {
  if (!(element instanceof Element)) {
    return
  }

  if (element.matches(SUBMIT_BUTTON_SELECTOR)) {
    return element
  }

  return element.closest(SUBMIT_BUTTON_SELECTOR)
}
/**
 * Get the text content of the submit button.
 * @param button
 */
export const getSubmitButtonText = (button) => {
  if (!(button instanceof Element)) {
    return
  }

  if (button.matches('input[type="submit"]')) {
    return normalizeText(button.value || '')
  }

  return normalizeText(
    button.textContent
    || button.getAttribute('aria-label')
    || ''
  )
}

/**
 * Get the action associated with the submit button.
 * @param button
 * @return {*|string}
 */
export function getSubmitButtonAction(button) {
  if (!(button instanceof Element)) {
    return 'submit'
  }

  return normalizeText(
    button.getAttribute('data-submit-action')
    || button.getAttribute('value')
    || 'submit'
  )
}

/**
 * Get the default submit button for a form.
 * @param form
 * @return {*}
 */
export function getDefaultSubmitButton(form) {
  return form.querySelector(SUBMIT_BUTTON_SELECTOR)
}

/**
 * Get the formie form for a given element.
 * @param element
 */
export function getForm(element) {
  if (!(element instanceof Element)) {
    return
  }
  if (element.tagName.toLowerCase() === 'form') {
    return element
  }
  return element.closest('.fui-form')
}

export function populateHiddenTrackingFields(form, { cid, utmParams }) {
  const cidField = form.querySelector('input[name="fields[cid]"]')
  if (cidField && cid) {
    cidField.value = cid
  }

  const utmField = form.querySelector('input[name="fields[utmParams]"]')
  if (utmField && utmParams) {
    utmField.value = utmParams
  }
}
export function extractFormMetadata(form) {
  if (!form) {
    return {}
  }

  const config = parseFormConfig(form)
  const dataset = form.dataset || {}

  const formHandle = dataset.formHandle || config.formHandle || ''
  const formId = parseFormId(config.formId)
  const formTitle = dataset.formTitle || formHandle
  const formSubmitMethod = dataset.formSubmitMethod || config?.settings?.submitMethod || ''
  const formSubmitAction = dataset.formSubmitAction || config?.settings?.submitAction || ''

  return {
    form_handle: normalizeText(formHandle),
    form_id: formId,
    form_title: normalizeText(formTitle),
    form_dom_id: normalizeText(form.id || config.formHashId || ''),
    form_submit_method: normalizeText(formSubmitMethod),
    form_submit_action: normalizeText(formSubmitAction),
  }
}
